const eventVariantService = (couponCategory, couponName, carModel, couponVariant, serviceType) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: 'generalEvent',
      eventName: `${serviceType === 'coupon' ? 'kupon' : 'paket'}_servis_pilih_variant_button`,
      eventCategory: `${serviceType === 'coupon' ? 'kupon' : 'paket'} servis page`,
      eventAction: `click on pilih ${serviceType === 'coupon' ? 'kupon' : 'paket'} servis`,
      eventLabel: `${couponCategory?.toLowerCase() || 'semua'} - ${couponName?.toLowerCase() || 'not available'} - pdp`,
      carModel: carModel?.toLowerCase() || 'not available',
      ...(serviceType === 'coupon' && {
        variantKuponServis: couponVariant?.toLowerCase() || 'not available',
      }),
      ...(serviceType === 'package' && {
        tipePaketServis: couponVariant?.toLowerCase() || 'not available',
      }),
    });
  }
};
export default eventVariantService;
